import classnames from "classnames";
import AssetComponent from "components/core/asset/asset-component";
import { StyledFadeInAssetComponent } from "./fade-in-asset-component.scss";

const FadeInAssetComponent = ({
  backgroundAsset,
  fadeInAsset,
  isInView,
  startingPosition,
  animationDuration,
  advancedAssetConfig
}) => (
  <StyledFadeInAssetComponent
    className="fade-in-asset-component"
    startingPosition={startingPosition}
    animationDuration={animationDuration}
    fadeInAssetHeight={fadeInAsset?.height}
  >
    <div className="background-asset-container">
      <AssetComponent {...backgroundAsset} {...advancedAssetConfig} />
    </div>
    <div className={classnames("fade-in-asset-container", { visible: isInView })}>
      <AssetComponent {...fadeInAsset} {...advancedAssetConfig} />
    </div>
  </StyledFadeInAssetComponent>
);

export default FadeInAssetComponent;
